/** Vite inlines these at build time; missing values fall back to the dev proxy. */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
export const IS_DEV = import.meta.env.DEV;

/**
 * Browser key for the Google Maps JavaScript API, used only for the address
 * search on the supplier form. Empty is a supported state: the search says
 * what is missing and the address is typed by hand, as it always could be.
 *
 * This key ships to the browser and cannot be secret. Restrict it by HTTP
 * referrer, and to the Maps JavaScript API and Places API (New), in the Google
 * Cloud console - that restriction, not secrecy, protects the quota. The admin
 * panel's key works here if this panel's origin is added to its referrers.
 */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '';
